export class MlToken {
  Provider = new MlProvider();
  AuthServer = new MlAuthServer();
  ApiServer = new MlApiServer();
  UserInfo = new MlUser();
  BranchInfo = new MlBranch();
  CompanyInfo = new MlCompany();
}
export class MlUser {
  UserSysID = 0;
  UserID = '';
  Fullname = '';
  RoleSysID = 0;
  RoleName = '';
  UserImageUrl = '';
  Mobile = '';
  Email = '';
  Address1 = '';
  Address2 = '';
  City = '';
  District = '';
  State = '';
  Country = '';
}
export class MlBranch {
  BranchSysID = 0;
  BranchID = '';
  BranchName = '';
}
export class MlCompany {
  CompanySysID = 0;
  CompanyID = '';
  CompanyName = '';
  CompanyLogo = '';
  ContactPerson = '';
}
export class MlAuthServer {
  IsTokenReady = false;
  Url = '';
  AuthKey = '';
  Username = '';
  Password = '';
  ProjectKey = '';
}
export class MlApiServer {
  IsTokenReady = false;
  Url = '';
  ApiKey = '';
}
export class MlProvider {
  Name = '';
  Email = '';
  Website = '';
  Mobile = '';
  Copyright = '';
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/interface/ICookies.ts